import {createContext} from "react";

// This context stores the execution tree instance information.
const DesignTreeInstanceContext = createContext();

export default DesignTreeInstanceContext;
